import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  dialog: {
    width: 587,
    minHeight: "80vh",
  },
  form: {
    position: "relative",
    height: "60vh"
  },
  closeButton: {
    fontWeight: "bold"
    
  },
  spinner: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    margin: "auto",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    overflowY: "auto",
  },
  title: {
    fontSize: 24,
    fontWeight: "bold"
  },
  input: {
    "& input": {
      paddingTop: 0,
      backgroundColor: "var(--bg-white)",
      borderColor: "grey",
      height: 40,
    },
  },
  field: {
    marginTop: 0
  },
  collapse: {
    borderRadius: 15,
    border: "solid 1px var(--bg-secondary)",
  },
  error: {
    color: theme.palette.error.main,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: "normal",
    marginLeft: 12,
  },
  collapseSummary: {
    backgroundColor: "var(--bg-secondary-light)",
    flexDirection: "row-reverse",
  },
  variables: {
    maxHeight: 300,
    overflowY: "auto",
  },
  collapseTitle: {
    marginLeft: 16,
    fontSize: "1rem",
    lineHeight: "normal",
  },
  formItem: {
    display: "flex",
    width: "100%",
    overflowY: "auto",
    flexDirection: "column",
  },
  label: {
    fontSize: 16,
    height: 25,
    marginTop: 10
  },
  Plabel: {
    fontSize: 16,
  },
  label2: {
    color: "grey",
  },
  fill: {
    backgroundColor: "black",
    color: "var(--color-secondary) !important",
    borderRadius: 30,
    border: "none !important",
    width: 150

  },
  unfill: {
    height: 40,
    width: "160px !important",
    backgroundColor: "var(--bg-border-gray) !important",
    color: "var(--color-secondary) !important",
    border: "none !important",
  },
  nameHelper: {
    width: "100%",
    textAlign: "end",
    fontSize: theme.typography.pxToRem(12),
  },
  dropdown: {
    width: 370,
    "& .MuiFormHelperText-root": {
      margin: "3px 0px 0px",
    },
  },
  actions: {
    display: "flex",
    gap: 24,
    justifyContent: "center",
    width: "100%",
  },
  btnBack: {
    fontSize: "1rem",
    marginLeft: -12,
  },
  backIcon: {
    marginRight: 4,
  },
  alert: {
    lineHeight: "normal",
  },
  blackPlaceholder: {
    "& input::placeholder": {
      color: "black",
      opacity:1

    },
  },
  grayPlaceholder: {
    "& input::placeholder": {
      color: "gray",
    },
  },
  betaBadge: {
    "& .MuiBadge-badge": {
      right: -20,
      top: 13,
    },
  },
}));
